/**
 * Created by mnaughton on 1/19/2016.
 */

import auth from "app/auth";
import $ from "jquery";
import _ from "underscore";
var RequestUtils = {
  get: function (url, success, err) {
    return $.ajax({
      url: url,
      success: success,
      error: err,
      headers: {
        Authorization: "Bearer " + auth.token,
      },
    });
  },

  /**
   * Call fetch on a backbone collection, but return a standard promise on the success and error options rather than the standard ajax promise.
   * @param {Backbone.Collection} collection The collection to fetch.
   * @param {String} [url] A url to set on the collection before fetching.
   */
  fetchToPromise: function (collection) {
    var deferred = new $.Deferred();

    collection.fetch({
      success: _.bind(deferred.resolve, deferred),
      error: _.partial(function (deferred, modelOrCollection, xhrError) {
        deferred.reject(xhrError);
      }, deferred),
    });

    return deferred.promise();
  },
};

var map = {
  post: "POST",
  put: "PUT",
  del: "DELETE",
};

_.each(map, function (method, name) {
  RequestUtils[name] = function (url, data, success, err) {
    if (_.isFunction(data)) {
      err = success;
      success = data;
      data = null;
    }

    return $.ajax({
      url: url,
      success: success,
      error: err,
      headers: {
        Authorization: "Bearer " + auth.token,
      },
      type: method,
      data: data,
    });
  };
});

export default RequestUtils;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/utils/RequestUtils.js
// module id = 34
// module chunks = 1